import { AxiosResponse } from 'axios';
import { ClientInfo } from '../../../../core/models/client-info';
import backendHttpClient from '../../../http/axios/axios-http-client';

const ENDPOINT = '/client-info';

export interface ClientInfoGateway {
  getClientInfo(clientUserProfileId: string): Promise<ClientInfo>;
}

export class ClientInfoGateway implements ClientInfoGateway {
  async getClientInfo(clientUserProfileId: string): Promise<ClientInfo> {
    const endpoint = `${ENDPOINT}/${clientUserProfileId}`;

    const response: AxiosResponse<ClientInfo> = await backendHttpClient.request({
      url: endpoint,
      method: 'GET',
    });

    return response.data;
  }
}

export default ClientInfoGateway;
